import { Component } from '@angular/core';
import { faSortDown, faSortUp, faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';


@Component({
  selector: 'app-legal-betting',
  templateUrl: './legal-betting.component.html',
  styleUrls: ['./legal-betting.component.scss']
})
export class LegalBettingComponent {
  faSortDown = faSortDown;
  faSortUp = faSortUp;
  faArrowRightLong = faArrowRightLong;

  items = [
      {name:'Arizona', status:'legal', link:'/betting/arizona'},
      {name:'Colorado', status:'legal', link:'/betting/colorado'},
      {name:'Connecticut', status:'legal', link:'/betting/connecticut'},
      {name:'Illinois', status:'legal',  link:'/betting/illinois'},
      {name:'Indiana', status:'legal', link:'/betting/indiana'},
      {name:'Iowa', status:'legal', link:'/betting/iowa'},
      {name:'Kansas', status:'legal', link:'/betting/kansas'},
      {name:'Kentucky', status:'legal', link:'/betting/kentucky'},
      {name:'Louisiana', status:'legal', link:'/betting/louisiana'},
      {name:'Maryland', status:'legal', link:'/betting/maryland'},
      {name:'Massachusetts', status:'legal', link:'/betting/massachusetts'},
      {name:'Michigan', status:'legal', link:'/betting/michigan'},
      {name:'New Jersey', status:'legal', link:'/betting/new-jersey'},
      {name:'New York', status:'legal',  link:'/betting/new-york'},
      {name:'Ohio', status:'legal', link:'/betting/ohio'},
      {name:'Pennsylvania', status:'legal', link:'/betting/pennsylvania'},
      {name:'Tennessee', status:'legal', link:'/betting/tennessee'},
      {name:'Virginia', status:'legal' , link:'/betting/virginia'},
      {name:'Washington D.C.', status:'legal', link:'/betting/washington-dc'},
      {name:'West Virginia', status:'legal', link:'/betting/west-virginia'},
      {name:'Wyoming', status:'legal', link:'/betting/wyoming'}
  ];
}
